import { render, staticRenderFns } from "./boss-header.vue?vue&type=template&id=5d5a86db&scoped=true"
import script from "./boss-header.vue?vue&type=script&lang=js"
export * from "./boss-header.vue?vue&type=script&lang=js"
import style0 from "./boss-header.vue?vue&type=style&index=0&id=5d5a86db&prod&scoped=true&lang=css"
import style1 from "./boss-header.vue?vue&type=style&index=1&id=5d5a86db&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5a86db",
  null
  
)

export default component.exports